import Vue from 'vue';
import hljs from 'highlight.js';
import 'highlight.js/styles/darcula.css';
import 'diff2html/bundles/css/diff2html.min.css';

Vue.use(hljs.vuePlugin);
